import type { RootState } from 'store'

export const getTnFromMention = (state: RootState) =>
  state.mentionEdit.tnFromMention

export const getVerificationState = (state: RootState) =>
  state.mentionEdit.verificationState

export const getImageManegementState = (state: RootState) =>
  state.mentionEdit.imageManagementState
